<template>
<div class="chapter">
<div class="inner_page">
<p class="p7"><span class="t7">By </span>B<span class="t8">RANDON</span> W<span class="t8">ITT</span></p>
<p class="p0"><span class="t7">Grand Adventures (Dreamspinner anthology)</span></p>
<p class="p0"><span class="t7">The Shattered Door</span></p>
<p class="p1"><span class="t7">Then the Stars Fall</span></p>
<p class="p0"><span class="t9">M</span><span class="t10">EN</span><span class="t9"> </span><span class="t10">OF</span><span class="t9"> M</span><span class="t10">YTH</span><span class="t9"> S</span><span class="t10">ERIES</span></p>
<p class="p0"><span class="t7">Submerging Inferno</span></p>
<p class="p0"><span class="t7">Rising Frenzy</span></p>
<p class="p0"><span class="t7">Clashing Tempest</span></p>
<p class="p8"><span class="t7">Published by </span>D<span class="t8">REAMSPINNER</span> P<span class="t8">RESS</span></p>
<p class="p0"><span class="t7">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?0aa69300